interface ProfileInfo {
  id: string;
  name: string;
  location: string;
}

interface PlayerInfo {
  id: string;
  name: string;
  connected: boolean;
  ready: boolean;
  score: number;
  whiteDicePhaseActionTaken: boolean;
  whiteDicePhaseBoxMarked: boolean;
  colorDicePhaseActionTaken: boolean;
  scoreCard: ScoreCardInfo;
  location: string;
}

interface ScoreCardInfo {
  red: number[];
  yellow: number[];
  blue: number[];
  green: number[];
  penalties: number;
}

interface GameInfo {
  id: string;
  currentTurn: number;
  currentPlayerIndex: number;
  dice: DiceInfo | undefined;
  phase: PhaseType | undefined;
  greenLocked: boolean;
  blueLocked: boolean;
  yellowLocked: boolean;
  redLocked: boolean;
  endReasons: string[] | undefined;
}

enum PhaseType {
  white = "white",
  color = "color",
  dice = "dice",
  end = "end",
}

interface SessionInfo {
  game?: GameInfo;
  players: PlayerInfo[];
}

interface DiceInfo {
  red: number;
  yellow: number;
  green: number;
  blue: number;
  white: number[];
}

interface DieInfo {
  color: string;
  number: number;
}

type ColorLockEventInfo = {
  player: string;
  color: string;
  session: SessionInfo;
};

type ScoreInfo = {
  playerID: string;
  playerName: string;
  score: number;
  turns: number;
  gameID: string;
  date: Date;
  playerCount: number | undefined | null;
};

export {
  ProfileInfo,
  PlayerInfo,
  GameInfo,
  SessionInfo,
  DiceInfo,
  ScoreCardInfo,
  DieInfo,
  PhaseType,
  ColorLockEventInfo,
  ScoreInfo,
};
